import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyNotSetupTemplate({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.28 136c-43.35 0-57.18 12-92.2 12C46 148 6.41 139.34 15 97.94 23.03 59.21 55.23 47.5 90.85 21c108.24-80.52 198.12 115 77.43 115z"
        fill="#FFE6CE"
      />
      <path
        opacity={0.16}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M168.28 136c-44.2-1.04-46.37 12-97.86 11-29.64 0-54.86-9.88-56.61-36-.81-34.35 65.4-7.86 92.65-23.52 56.38-32.42 112.99 28.47 103.33 36.35-9.66 7.88-24.98 12.56-41.5 12.17z"
        fill="#FB8F23"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M184.54 76.07a8 8 0 00-9.96 6.4l-6 27.43a6.67 6.67 0 0012.72 3.99l.03.01 8.65-27.34c.08-.23.16-.46.22-.7a8 8 0 00-5.66-9.79zm-17.08 63.75a8 8 0 104.14-15.45 8 8 0 00-4.14 15.45z"
        fill="#FCC083"
      />
      <rect
        x={75}
        y={27}
        width={86}
        height={100}
        rx={4}
        fill="#fff"
        filter="url(#pic-empty-not-setup-template_svg__a)"
      />
      <rect opacity={0.16} x={115} y={42} width={36} height={16} rx={1} fill="#9F9F9F" />
      <rect opacity={0.16} x={85} y={68} width={66} height={6} rx={1} fill="#9F9F9F" />
      <rect opacity={0.16} x={85} y={80} width={66} height={6} rx={1} fill="#9F9F9F" />
      <rect opacity={0.16} x={85} y={92} width={40} height={6} rx={1} fill="#9F9F9F" />
      <path
        d="M94.88 37.22a1 1 0 011.85 0l2.54 6.12a1 1 0 00.84.61l6.61.53a1 1 0 01.57 1.76l-5.03 4.3a1 1 0 00-.32 1l1.53 6.45a1 1 0 01-1.49 1.08l-5.66-3.45a1 1 0 00-1.04 0l-5.65 3.45a1 1 0 01-1.5-1.08l1.54-6.45a1 1 0 00-.32-1l-5.04-4.3a1 1 0 01.57-1.76l6.61-.53a1 1 0 00.84-.61l2.55-6.12z"
        fill="#FECE00"
      />
      <circle
        cx={74}
        cy={132}
        r={32}
        fill="#fff"
        filter="url(#pic-empty-not-setup-template_svg__b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.71 121.45l-4 4.03-3.92-.71-.7-3.91 4-4.03a4.39 4.39 0 00-3.13-1.26c-.96.05-3 .59-4.6 2.27-1.53 1.62-3.14 4.64-1.71 7.99.17.4.36.94-.2 1.5-.58.57-17.2 16.34-17.2 16.34-1.38 1.19-1.28 3.38-.01 4.66 1.3 1.27 3.47 1.35 4.66-.02 0 0 15.65-16.55 16.32-17.21.6-.6 1.15-.4 1.5-.2 2.54 1.3 6.14.16 8-1.7a7.08 7.08 0 002.27-4.6 4.16 4.16 0 00-1.28-3.15zm-28.24 25.26c-.45.44-1.18.44-1.62 0a1.15 1.15 0 010-1.62 1.15 1.15 0 011.62 0c.44.45.44 1.18 0 1.62z"
        fill="#FB8F23"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.24 129.47l-2.54 2.46-5.3-5.27-1.27 1.23-7.13-6.9 5.09-4.93 7.12 6.9-1.27 1.23 5.3 5.28zM88.7 146.8l-2.04 1.98a3.68 3.68 0 01-5.09 0s-8.15-8.25-8.03-7.96c3-5.06 7.36-6.2 7.36-6.2l7.8 7.26a3.4 3.4 0 010 4.93zm-12.1-6.96a.86.86 0 000 1.24l6.54 6.34c.35.34.92.34 1.28 0a.86.86 0 000-1.24l-6.55-6.34a.92.92 0 00-1.27 0zm10.7 3.55l-6.55-6.34a.92.92 0 00-1.28 0 .85.85 0 000 1.24l6.55 6.34c.35.34.92.34 1.27 0a.86.86 0 000-1.24z"
        fill="#FB8F23"
      />
      <defs>
        <filter
          id="pic-empty-not-setup-template_svg__a"
          x={71}
          y={25}
          width={94}
          height={108}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2152_1457" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2152_1457" result="shape" />
        </filter>
        <filter
          id="pic-empty-not-setup-template_svg__b"
          x={38}
          y={96}
          width={72}
          height={72}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.12 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2152_1457" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2152_1457" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyNotSetupTemplate.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyNotSetupTemplate.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyNotSetupTemplate svgRef={ref} {...props} />
));
export default ForwardRef;
